import React from 'react';
import { PresetPrompt, ModelId } from './types';

// Icons as simple SVG components for portability within this file structure
// Icons as simple SVG components for portability within this file structure
const Zap = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" /></svg>
);

const ScanEye = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 7V5a2 2 0 0 1 2-2h2" /><path d="M17 3h2a2 2 0 0 1 2 2v2" /><path d="M21 17v2a2 2 0 0 1-2 2h-2" /><path d="M7 21H5a2 2 0 0 1-2-2v-2" /><circle cx="12" cy="12" r="3" /><path d="M12 16v5" /><path d="M16 12h5" /><path d="M12 8V3" /><path d="M8 12H3" /></svg>
);

const Layers = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polygon points="12 2 2 7 12 12 22 7 12 2" /><polyline points="2 17 12 22 22 17" /><polyline points="2 12 12 17 22 12" /></svg>
);

const RotateCw = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 12a9 9 0 1 1-9-9c2.52 0 4.93 1 6.74 2.74L21 8" /><path d="M21 3v5h-5" /></svg>
);

export const MODELS: Record<ModelId, { label: string; priceInput: number; priceOutput: number; isPaid?: boolean }> = {
  'gemini-2.5-flash-image': {
    label: 'Gemini 2.5 Flash (Nano Banana)',
    priceInput: 0.15,
    priceOutput: 0.039, // Updated per real usage stats (~$30/1M output tokens)
    isPaid: false
  },
  'gemini-3-flash-preview': {
    label: 'Gemini 3.0 Flash Preview',
    priceInput: 0.50,
    priceOutput: 3.00, // Text output pricing ($3.00/1M)
    isPaid: false
  },
  'gemini-3-pro-image-preview': {
    label: 'Gemini 3.0 Pro (Nano Banana Pro)',
    priceInput: 2.50,
    priceOutput: 0.134, // Updated per real usage stats (~$120/1M output tokens)
    isPaid: true
  }
};

export const PRESET_PROMPTS: PresetPrompt[] = [
  {
    id: 'enhance',
    label: 'Enhance Quality',
    prompt: 'Upscale the image, improve resolution, sharpen details, and improve lighting for a high-end photography look.',
    icon: <Zap />,
    description: 'Upscale & sharpen details'
  },
  {
    id: 'smart-enhance',
    label: 'Smart Enhancement',
    prompt: '2-step workflow: 1. Analyze defects (Flash 3.0) -> 2. Fix & Upscale 4K (Pro 3.0) with strict object fidelity.',
    icon: <ScanEye />,
    description: 'Analyze + Fix (4K Fidelity)'
  },
  {
    id: 'isolate-object',
    label: 'Isolate Object',
    prompt: 'Isolate the subject on a white background. CRITICAL: Preserve the subject EXACTLY as is. Do not enhance, sharpen, or modify the subject details. Pixel-perfect isolation only.',
    icon: <Layers />,
    description: 'Remove background'
  },
  {
    id: 'align-object',
    label: 'Align Object',
    prompt: 'Rotate and tight-crop the object for print optimization.',
    icon: <RotateCw />,
    description: 'Rotate & Crop for Print'
  },
];